import {
    Fragment,
} from 'react'
import { Menu, Transition } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/solid'
import { classNames } from '@progress/kendo-react-common'
import React from 'react'
import { ServiceDiscountType, ServiceDiscountTypes } from 'types/service'
import Translation from 'components/Translation'

type ServiceDiscountTypeSelectorProps = { //TODO: make a generic variant for selectors with images
    setSelectedItem: (selected: ServiceDiscountType) => void
    selected_item: ServiceDiscountType
}

export function ServiceDiscountTypeSelector(props: ServiceDiscountTypeSelectorProps) {

    return (
        <Menu
            as="div"
            className={classNames(
                'relative inline-block text-left w-full'
            )}
        >
            {({ open }) => (
                <>
                    <Menu.Button
                        className={
                            'inline-flex text-left items-center w-full rounded-md border border-gray-150 shadow-sm p-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 '
                        }
                    >
                        {/* TODO: insert selected info here */}
                        <div className='flex flex-row items-center flex-grow'>
                            <img
                                className='w-5 h-5'
                                src={props.selected_item.active}
                                alt="Active"
                            />
                            <Translation
                                render_as='span'
                                className='my-auto ml-3'
                                content_key={props.selected_item.translation}
                            />
                        </div>
                        <ChevronDownIcon
                            className="-mr-1 ml-2 h-6 w-6 text-xl text-gray-500/80"
                            aria-hidden="true"
                        />
                    </Menu.Button>

                    <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                        show={open}
                    >
                        <Menu.Items
                            static
                            className={classNames(
                                'absolute mt-2 w-full rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10'
                            )}
                        >
                            <div className="p-1">
                                {ServiceDiscountTypes.map(
                                    (v, idx) => {
                                        return (
                                            <Menu.Item key={v.value}>
                                                {({ active }) => (
                                                    <div
                                                        className={classNames(
                                                            active
                                                                ? 'bg-[#86C5E0]/10'
                                                                : 'bg-white',
                                                            'flex flex-row text-xs font-medium font-[#58595B] p-2 rounded-lg',
                                                        )}
                                                        onClick={() => {
                                                            props.setSelectedItem(v)
                                                        }}
                                                    >
                                                        <div className='flex flex-row'>
                                                            <img
                                                                className='w-6 h-6'
                                                                src={active ? v.active : v.inactive}
                                                                alt={active ? 'active' : 'inactive'}
                                                            />
                                                            <Translation
                                                                render_as='span'
                                                                className='my-auto ml-3'
                                                                content_key={v.translation}
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                            </Menu.Item>
                                        )
                                    }
                                )}
                            </div>
                        </Menu.Items>
                    </Transition>
                </>
            )}
        </Menu>
    )
}

export default ServiceDiscountTypeSelector
